"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  PlasmicComponent: () => plasmic_component_default,
  PlasmicComponentLoader: () => import_loader_react2.PlasmicComponentLoader,
  PlasmicRootProvider: () => plasmic_root_provider_default,
  PlasmicVue: () => install_default,
  initPlasmicLoader: () => import_loader_react2.initPlasmicLoader
});
module.exports = __toCommonJS(src_exports);
var import_loader_react2 = require("@plasmicapp/loader-react");

// src/components/plasmic-component.ts
var import_loader_react = require("@plasmicapp/loader-react");
var import_vue_demi = require("vue-demi");

// src/context.ts
var PLASMIC_CONTEXT = Symbol("PlasmicContext");

// src/components/plasmic-component.ts
var isServer = typeof window === "undefined";
var plasmic_component_default = (0, import_vue_demi.defineComponent)({
  name: "PlasmicComponent",
  props: {
    component: {
      type: String,
      required: true
    },
    componentProps: {
      type: Object
    }
  },
  methods: {
    updateElement() {
      const element = this.root;
      if (element && element instanceof HTMLElement) {
        (0, import_loader_react.renderToElement)(this.context.loader, element, this.$props.component, {
          prefetchedData: this.context.prefetchedData,
          componentProps: this.$props.componentProps,
          globalVariants: this.context.globalVariants
        });
      }
    }
  },
  setup() {
    const context = (0, import_vue_demi.inject)(PLASMIC_CONTEXT);
    const root = (0, import_vue_demi.ref)(null);
    if (!context) {
      throw new Error(
        "<PlasmicComponent> should be wrapped inside a <PlasmicRootProvider>"
      );
    }
    return {
      root,
      context
    };
  },
  watch: {
    component: function() {
      this.updateElement();
    },
    componentProps: function() {
      this.updateElement();
    }
  },
  mounted() {
    this.updateElement();
  },
  render() {
    return (0, import_vue_demi.h)("div", __spreadValues({
      ref: "root"
    }, isServer && {
      // Generate html if we are doing server-side rendering
      domProps: {
        innerHTML: (0, import_loader_react.renderToString)(
          this.context.loader,
          { name: this.$props.component },
          {
            prefetchedData: this.context.prefetchedData,
            componentProps: __spreadValues({}, this.$props.componentProps),
            globalVariants: this.context.globalVariants
          }
        )
      }
    }));
  }
});

// src/components/plasmic-root-provider.ts
var import_vue_demi2 = require("vue-demi");
var plasmic_root_provider_default = (0, import_vue_demi2.defineComponent)({
  name: "PlasmicRootProvider",
  props: {
    loader: {
      type: Object,
      required: true
    },
    globalVariants: {
      type: Array
    },
    prefetchedData: {
      type: Object
    }
  },
  setup(props, { slots }) {
    (0, import_vue_demi2.provide)(PLASMIC_CONTEXT, {
      loader: props.loader,
      globalVariants: props.globalVariants,
      prefetchedData: props.prefetchedData
    });
    return () => (0, import_vue_demi2.h)("div", slots.default());
  }
});

// src/install.ts
var import_vue_demi3 = require("vue-demi");
var install = import_vue_demi3.isVue2 ? void 0 : (app) => {
  app.component(plasmic_root_provider_default.name, plasmic_root_provider_default);
  app.component(plasmic_component_default.name, plasmic_component_default);
};
var install_default = install;
//# sourceMappingURL=index.js.map
